import { useEffect, useState } from 'react';

export default function SelectionCheckbox({ id, srText, selected, onChange }) {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(selected ?? false);
  }, [selected]);

  function handleChange(event) {
    const selected = event.target.checked;
    setChecked(selected);
    onChange(selected);
  }

  return (
    <>
      <label htmlFor={id} className="sr-only">
        {srText}
      </label>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={handleChange}
      ></input>
    </>
  );
}
